export const getFlow = ( state ) => {
 return state.flow
}

export const getSessionType = ( state ) => {
 return state.sessionType
}